import React from "react";
import classnames from "classnames";
import bitsIcon from "../../../../assets/images/bits_icon.svg";
import style from "./CheerItem.module.scss";
import StrokedEmoteImage from "../Emotes/StrokedEmoteImage";
import GA from "../../../../common/services/GA";

export interface CheerData {
  img?: string;
  title: string;
  subtitle?: string;
  amount: number;
}

interface CheerItemProps extends CheerData {
  isTopCheersType?: boolean;
  className?: string;
  titleClassName?: string;
}

const CheerItem: React.FC<CheerItemProps> = ({
  isTopCheersType,
  title,
  subtitle,
  img,
  amount,
  className,
  titleClassName,
}) => {
  return (
    <div
      className={classnames(style.cheerItem, className, {
        [style.cheerItem_topCheer]: isTopCheersType,
      })}
      onClick={() => GA.sendEvent("click", isTopCheersType ? "cheerleaders_row_click" : "cheer_row_click", title)}
    >
      <div className={style.cheerItem__wrapper}>
        {img && <StrokedEmoteImage src={img} className={style.cheerItem__image} />}
        <div>
          <div className={classnames(style.cheerItem__title, titleClassName)}>{title}</div>
          <div className={style.cheerItem__subtitle}>{subtitle}</div>
        </div>
      </div>

      <div className={style.cheerItem__amountWrapper}>
        <span className={style.cheerItem__amount}>{amount}</span>
        <img className={style.cheerItem__bitsImage} src={bitsIcon} />
      </div>
    </div>
  );
};

export default CheerItem;
